export interface CloudflareTraceResult {
  ip: string;
  loc: string;
}

async function getIpFromCloudflare(): Promise<CloudflareTraceResult | null> {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 1000);

    const result = await fetch('https://www.cloudflare.com/cdn-cgi/trace', {
      method: 'GET',
      signal: controller.signal,
    })
      .then((res) => res.text())
      .then((t) => {
        /* eslint-disable no-useless-escape */
        let data = t.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
        data = `{"${data.slice(0, data.lastIndexOf('","'))}"}`;
        const jsondata = JSON.parse(data);
        return { ip: jsondata.ip as string, loc: jsondata.loc as string };
      });

    clearTimeout(timeoutId);

    return result;
  } catch (err: any) {
    // eslint-disable-next-line no-console
    console.error('❌ cloudflare IP trace', err);
  }

  return null;
}

export default getIpFromCloudflare;
